import { render, staticRenderFns } from "./ListContacts.html?vue&type=template&id=bf8559de&scoped=true&"
import script from "./ListContacts.js?vue&type=script&lang=js&"
export * from "./ListContacts.js?vue&type=script&lang=js&"
import style0 from "./ListContacts.scss?vue&type=style&index=0&id=bf8559de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8559de",
  null
  
)

export default component.exports